<template>
    <div class="min-h-screen flex flex-col ">
        <TopHeader class="max-lg:hidden" />
        <div class="container">
            <FoodHeader class="max-lg:mt-5" />
            <main class="flex-auto max-md:px-3.75">
                <router-view />
            </main>
            <FoodNav></FoodNav>
        </div>
        <TheFooter></TheFooter>
    </div>
	<PageUpButton />

</template>

<script>

import TopHeader from '@/components/TopHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import FoodHeader from '@/components/food/FoodHeader.vue'
import FoodNav from '@/components/food/FoodNav.vue'
import { updateLastSeen } from '@/helpers'
import api from '@/api';
import PageUpButton from '@/components/PageUpButton.vue'

export default {
    name: 'FoodLayout',
    components: {
        TopHeader,
        FoodHeader,
        TheFooter,
        FoodNav,
        PageUpButton
    },
    data(){
        return {
            loading: false
        }
    },
    methods: {
  


        // async postLastSeen(){
        //     try{
        //         const response = await api.post('last_seen/', { mall_products })

        //     }catch(e){
        //         console.log(e)
        //     }
        // }
    },
    mounted() {
        updateLastSeen('exhibition_stores')
    },
    computed: {

    },
    created(){

    }
}

</script>